<template>
    <div>
        <div slot="notification">
            <notification :notification="notification"></notification>
        </div>

        <div>
            <p class="title">Basic Settings</p>

            <b-form class="mt-5">
                <strong>Security</strong>
                <hr>
                <b-form-row>
                    <b-col>
                        <b-form-group horizontal label="Email:">
                            <b-form-input type="email"
                                          v-validate="'required|email'"
                                          v-model="form.email"
                                          :value="authUser.email"
                                          name="email"
                                          placeholder="Enter Your Email">
                            </b-form-input>
                            <span class="error">{{errors.first('email')}}</span>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group horizontal label="Name:">
                            <b-form-input type="text"
                                          name="name"
                                          v-model="form.name"
                                          v-validate="'required'"
                                          :value="authUser.name"
                                          required
                                          placeholder="Enter Your Name">
                            </b-form-input>
                            <span class="error">{{errors.first('name')}}</span>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <div class="mb-3 text-right">
                    <p class="text-right">
                        <a href="#" v-b-modal.change-password class="text-orange">Change password</a>
                    </p>
                </div>
                <b-form-group class="text-right mt-5">
                    <b-button @click="update"
                              class="btn btn-orange ">
                        <i class="dripicons-checkmark"></i>Save
                    </b-button>
                    <b-link :to="{ name: 'UserList' }" class="btn btn-secondary">
                        <i class="dripicons-cross"></i> Cancel
                    </b-link>
                </b-form-group>
            </b-form>
        </div>
        <b-modal @ok="changePassword" ok-variant="orange" id="change-password" centered title="Change password">
            <b-form-group>
                <b-input v-model="new_password" type="password" placeholder="please enter your new password"></b-input>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import * as USER from '@/store/constants/user'

  import NotificationMixin from '@/mixins/notification';

  import Notification from '@/views/Common/Notification';


  export default {
    inject: ['$validator'],
    data() {
      return {
        form: {},
        new_password: null
      }
    },
    mixins: [NotificationMixin],
    computed: {
      ...mapGetters({
        authUser: USER.GET_USER
      })
    },

    components: {Notification},

    methods: {
      ...mapActions({
        updateUser: USER.ACTION_UPDATE
      }),

      changePassword() {
        this.form.password = this.new_password;
      },

      /**
       * Update user information.
       */
      update() {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.updateUser({id: this.authUser.id, payload: this.form, selfUpdate: true}).then(res => {
              this.showSuccessNotification('User settings successfully updated');
            }).catch(e => {
              this.showErrorNotification(e.response.data.message);
            })
          }
        })
      }
    },
    created() {
      this.form = {...this.authUser};
      console.log(this.form);
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Setting/Basic/BasicSettings.vue